import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { ReportingProviderDto } from '../models/reporting-provider-dto';
import { createHttpParams } from 'src/utilities/api-utilities';

@Injectable({ providedIn: 'root' })
export class ReportingProviderApiService {
  private readonly http = inject(HttpClient);

  private readonly baseUrl = environment.apiUrl;

  public getReportingProviders(practiceId: number, queryParams?: { maxResultDays: number }): Observable<ReportingProviderDto[]> {
    const params = createHttpParams({ ...queryParams, practiceId } as unknown as Record<string, string | number>);

    return this.http.get<ReportingProviderDto[]>(`${this.baseUrl}/reporting-providers`, {
      params
    });
  }
}
